import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/catalyst/button';
import { ErrorPageLayout } from '@/components/errors/ErrorPageLayout';
import { useAuth } from '@/app/providers/AuthProvider';

/**
 * Pagina Forbidden - mostrata agli utenti autorizzati ma senza permessi admin
 * Diversa da Unauthorized che è per utenti non nel dominio
 */
const Forbidden: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const roleLabel = user?.role === 'user' ? 'Utente' : user?.role || 'Utente';

  return (
    <ErrorPageLayout
      code="403"
      label="AREA RISERVATA"
      title="Accesso non autorizzato"
      description="Non disponi dei permessi necessari per accedere a questa sezione."
      details={
        user && (
          <div className="mt-12 max-w-lg border-t border-zinc-200 pt-5 dark:border-white/10">
            <p className="text-xs font-medium text-zinc-600 dark:text-zinc-400">Accesso effettuato come</p>
            <div className="mt-3 flex min-w-0 max-w-full items-center gap-2">
              <p className="min-w-0 truncate text-sm font-medium text-zinc-900 dark:text-zinc-200" title={user.email}>
                {user.email}
              </p>
              <Badge color="zinc" className="shrink-0">
                {roleLabel}
              </Badge>
            </div>
          </div>
        )
      }
      actions={
        <>
          <Button
            type="button"
            color="dark/white"
            onClick={() => navigate('/')}
            className="focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-700 dark:focus-visible:outline-zinc-200"
          >
            Torna alla dashboard
          </Button>
          <Button
            href="mailto:it@polo9.org?subject=Richiesta%20di%20accesso"
            plain
            className="!px-0 !text-sm !font-medium !text-zinc-600 hover:!text-zinc-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-700 dark:!text-zinc-400 dark:hover:!text-zinc-200 dark:focus-visible:outline-zinc-200"
          >
            Contatta il supporto IT <span aria-hidden="true">→</span>
          </Button>
        </>
      }
    />
  );
};

export default Forbidden;
